<template lang="html">
  <vs-card class="cardx">
    <div
      slot="header"
      style="
        padding: 10px;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
      "
    >
      <h3>
        User History:
        {{ name }} ( {{ trips.pagination.total }} viajes )
      </h3>
    </div>

    <div>
      <vs-row>
        <vs-col vs-lg="6" vs-sm="6" vs-xs="6">
          <div class="mb-2">
            <vs-dropdown
              class="mr-2 mt-4"
              style="float: left"
              vs-custom-content
              vs-trigger-click
              vs-drop-right
              :vs-dropdown-visible="true"
            >
              <vs-chip transparent color="primary" style="min-width: 130px">
                <calendar-icon size="12" class="mr-1" />
                <b>From</b>: {{ since }}
              </vs-chip>
              <vs-dropdown-menu class="loginx">
                <datepicker
                  @input="updateDateQuery"
                  calendar-class="border-none"
                  :inline="true"
                  v-model="dates.since"
                  format="yyyy-MM-dd"
                ></datepicker>
              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-dropdown
              class="mr-2 mt-4"
              style="float: left"
              vs-custom-content
              vs-trigger-click
              vs-drop-right
              :vs-dropdown-visible="true"
            >
              <vs-chip transparent color="primary" style="min-width: 130px">
                <calendar-icon size="12" class="mr-1" /> <b>To</b>: {{ until }}
              </vs-chip>
              <vs-dropdown-menu class="loginx">
                <datepicker
                  @input="updateDateQuery"
                  calendar-class="border-none"
                  :inline="true"
                  v-model="dates.until"
                  format="yyyy-MM-dd"
                ></datepicker>
              </vs-dropdown-menu>
            </vs-dropdown>

            <div style="margin-bottom: 10px; width: 205px; float: left">
              <label class="vs-input--label">Route</label>

              <v-select
                @input="filters.page = 1"
                v-model="filters.route_id"
                :options="this.routedata"
                :reduce="(el) => el.id"
                label="name"
              />
            </div>
          </div>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="6" vs-xs="6">
          <div style="float: right">
            <vs-button
              class="mr-3 mb-3 mt-4"
              @click="download"
              color="primary"
              type="filled"
              >Download</vs-button
            >
          </div>
          <span style="float: right" class="mr-3 mt-4">
            <vs-select
              @input="filters.page = 1"
              class=""
              label=""
              v-model="filters.limit"
              width="100px"
              size="small"
            >
              <vs-select-item
                :key="'lim-' + index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in limitOptions"
              />
            </vs-select>
          </span>
        </vs-col>
      </vs-row>
      <vs-table stripe :sst="true" :data="trips.trips">
        <template slot="thead">
          <vs-th> Date </vs-th>
          <vs-th> Route </vs-th>
          <vs-th> Vehicle </vs-th>
          <vs-th> Driver </vs-th>
          <vs-th> Check-In </vs-th>
          <vs-th> Location </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(trip, index) in data">
            <vs-td>
              {{ trip.date }}
            </vs-td>
            <vs-td>
              {{ trip.route.name }}
            </vs-td>
            <vs-td>
              {{ trip.vehicle.eco_number }}
            </vs-td>
            <vs-td>
              {{ trip.driver.firstname }} {{ trip.driver.lastname }}
            </vs-td>
            <vs-td>
              {{ trip.checkin.created_at }}
            </vs-td>
            <vs-td>
              <a
                target="_blank"
                :href="
                  'https://maps.google.com/?q=' +
                  trip.checkin.latitude +
                  ',' +
                  trip.checkin.longitude
                "
              >
                {{ trip.checkin.latitude }},{{ trip.checkin.longitude }}
              </a>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-3 mb-3">
        <pagination
          :last-page="trips.pagination.pages"
          v-model="filters.page"
        />
      </div>
    </div>
  </vs-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { CalendarIcon } from "vue-feather-icons";
import limitOptions from "../../../constants/limit";
const FileDownload = require("js-file-download");
export default {
  components: {
    Datepicker,
    CalendarIcon,
  },
  props: {
    type: {
      type: String,
      default() {
        return "trips";
      },
    },
  },
  name: "list",
  data() {
    return {
      routedata: [],
      filters: [],
      route_id: null,
      dates: {
        since: moment().subtract(1, "weeks").toDate(),
        until: moment().toDate(),
      },
      page: 1,
      name: "",
      trips: {
        trips: [],
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
          pages: 0,
          prev: null,
          next: null,
        },
        zone_type: "PUBLIC",
      },

      limitOptions,
    };
  },
  computed: {
    ...mapState("trips", ["currentPage"]),
    ...mapState(["partner_namespace"]),
    since() {
      return moment(this.dates.since).format("YYYY-MM-DD");
    },
    until() {
      return moment(this.dates.until).format("YYYY-MM-DD");
    },
  },
  watch: {
    page(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.doSearch();
      }
    },
    filters: {
      deep: true,
      handler(newVal, oldVal) {
        this.setRouteQuery();
        //if(!_.isEqual(newVal, oldVal))
        this.doSearch();
      },
    },
  },
  created() {
    if (this.$route.query.since) {
      this.dates.since = moment(this.$route.query.since).toDate();
    }
    if (this.$route.query.until) {
      this.dates.until = moment(this.$route.query.until).toDate();
    }

    this.filters = {
      limit: "20",
      ...this.$route.query,
      page: this.$route.query.page ? Number(this.$route.query.page) : 1,
    };
    this.doSearch = _.debounce(this.getItems, 300);
  },
  methods: {
    ...mapActions("customers", [
      "fetchCustomersTrips",
      "fetchCustomerDetails",
      "fetchCustomerRoutes",
      "downloadTripReport",
    ]),
    setRouteQuery() {
      let query = { ...this.filters, page: `${this.filters.page}` };
      if (!_.isEqual(query, this.$route.query)) {
        try {
          this.$router.push({ query });
        } catch (error) {}
      }
    },
    getItems(search) {
      if (this.page > 1 && this.page > this.trips.pagination.pages) {
        this.page = this.trips.pagination.pages;
      }

      let payload = {
        id: this.$route.params.id,
        type: this.type,
        ...this.filters,
      };

      this.fetchCustomerDetails(payload)
        .then((data) => {
          this.name = data.name;
        })
        .catch((error) => {});

      this.fetchCustomerRoutes(payload)
        .then((data) => {
          this.routedata = data.routes;
        })
        .catch((error) => {});

      this.fetchCustomersTrips(payload)
        .then((data) => {
          this.trips = data;
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },

    updateDateQuery() {
      this.filters = {
        ...this.filters,
        page: 1,
        since: this.since,
        until: this.until,
      };
    },
    download() {
      this.$vs.loading({ type: "point" });
      this.downloadTripReport({
        since: this.since,
        until: this.until,
        export: true,
        id: this.$route.params.id,
        format: "csv",
        route_id: this.filters.route_id,
      })
        .then((response) => {
          FileDownload(response.data, `report-${this.since}-${this.until}.csv`);
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.warn("Error getting reports: ", error);
          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style scoped></style>
